import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';
import moment from 'moment';
import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-worker-end-shift',
  templateUrl: './worker-end-shift.component.html',
  styleUrls: ['./worker-end-shift.component.scss']
})
export class WorkerEndShiftComponent implements OnInit {

  workers: any;

  monitors:any = [];
  groups:any = [];

  u = Utils;

  filter:any = {
    monitors:[],
    groups:[],
    search:""
  };

  enable_created = false;
  enable_shift = false;

  created: any;
  shift: any;

  selected_workers:any = [];

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {


    this.created = { startDate: moment().subtract(1, 'months'), endDate: moment() }
    this.shift = { startDate: moment().subtract(1, 'months'), endDate: moment() }

    this.getWorkers();
  }

  getWorkers(){

    let filter:any = {
      search: this.filter.search,
      groups: this.filter.groups.join(","),
      monitors: this.filter.monitors.join(","),
      expand:'status'
    }

    if(this.enable_created){
      filter.created_start = this.created.startDate.format("YYYY-MM-DD");
      filter.created_end = this.created.endDate.format("YYYY-MM-DD");

    }

    if(this.enable_shift){

      filter.shift_start = this.shift.startDate.format("YYYY-MM-DD");
      filter.shift_end = this.shift.endDate.format("YYYY-MM-DD");
    }


    this.okService.get('reports/workerendshifts',filter)
    .subscribe((data) => {

      //console.log(data.body);

      this.workers = data.body;

    });
  }

  endWorkerShift(worker:any){

    let worker_ids = [worker.id];

    //console.log(worker_ids);

    this.okService.post("workers/massendshift",{ids:worker_ids})
    .subscribe((data) => {

      //console.log(data.body);

      this.getWorkers();

      this.okService.setAlert(this.transloco.translate("The worker has had their shift ended"),"success");

    });

  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.created = { startDate: moment().subtract(1, 'months'), endDate: moment() }
    this.shift = { startDate: moment().subtract(1, 'months'), endDate: moment() }
    this.enable_created = false;
    this.enable_shift = false;
    this.filter = {
      monitors:[],
      groups:[],
      search:""
    };
    
    this.getWorkers();

  }

  selectAll(){
    this.selected_workers = [];
    let self = this;

    _.forEach(this.workers, function(w:any) {
      self.selected_workers.push(w['id']);
    });

    //console.log(this.selected_workers);
  }

  deSelectAll(){
    this.selected_workers = [];
  }

  toggleWorker(worker_id:any){
    //console.log(worker_id);
    if(this.selected_workers.includes(worker_id)){

      _.remove(this.selected_workers, function(n:any) {
        return n == worker_id;
      });

    }else{
      this.selected_workers.push(worker_id);
    }
    //console.log(this.selected_workers);

  }

  clickEndShifts(){
    if(this.selected_workers.length > 0){
      if(confirm("Are you sure you want to end shifts for the "+this.selected_workers.length+" workers")){

        this.okService.post("workers/massendshift",{ids:this.selected_workers})
        .subscribe((data) => {

          //console.log(data.body);

          this.getWorkers();

          this.okService.setAlert(this.transloco.translate("The worker has had their shift ended"),"success");

        });

      }
    }
  }

}
